import { Injectable } from '@angular/core';

import { Observable, Subject, of } from 'rxjs';

import { ControlPropertyHandler } from './control-property-handler';
import { AbstractPropertyEditor } from '../types';
import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

@Injectable({
  providedIn: 'root'
})
export class TemplateUrlPropertyService implements ControlPropertyHandler<string> {
  propertyName: string = 'templateUrl';

  constructor(private commonConfig: DynamicFormCommonConfig) {}

  handleData(data: string, editor: AbstractPropertyEditor): Observable<string> {
    const sub = new Subject<string>();
    if (data) {
      const reg = editor.settings.reg;
      if (!reg.test(data)) {
        this.commonConfig.log.error(`æ¨¡æ¿æ ¼å¼æ ¡éªéè¯¯ï¼è¯·å¡«åæ­£ç¡®urlå°å`);
        sub.error('');
        sub.complete();
        return sub;
      }
    }
    return of(data);
  }
}
